import { defineMessages } from 'react-intl';


export default defineMessages({
  enter: {
    id: 'fullscreen.enter',
    defaultMessage: 'Full screen',
  },
  exit: {
    id: 'fullscreen.exit',
    defaultMessage: 'Exit full screen',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/fullscreen/translations.js